module.exports = __webpack_public_path__ + "img/social_dis.1144570c.png";